import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Input } from 'components/ui/input';
import { Textarea } from 'components/ui/textarea';
import MultiSelectCategories from './MultiSelectCategories';

const fieldClass = 'space-y-1 min-w-0';
const labelClass = 'block text-[13px] font-medium text-[#4c5f52]';
const inputClass = 'h-10 border-[#d4dfd7]';

const AgencyFormContent = ({ register, errors, control, categories, includeAdmin = false }) => (
  <>
    <section className="space-y-3">
      <h3 className="text-sm font-semibold text-[#354c3c]">Informations de la société</h3>
      <div className="grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-2">
        <div className={`${fieldClass} sm:col-span-2`}>
          <label className={labelClass} htmlFor="agency-name">
            Raison sociale
          </label>
          <Input id="agency-name" className={inputClass} placeholder="Nom de la société" {...register('name')} />
          {errors.name && <p className="text-xs text-red-500">{errors.name.message}</p>}
        </div>
        <div className={fieldClass}>
          <label className={labelClass} htmlFor="agency-ifu">
            Numéro IFU
          </label>
          <Input
            id="agency-ifu"
            className={inputClass}
            placeholder="3202300000000"
            maxLength={13}
            {...register('ifu')}
          />
          {errors.ifu && <p className="text-xs text-red-500">{errors.ifu.message}</p>}
        </div>
        <div className={fieldClass}>
          <label className={labelClass} htmlFor="agency-phone">
            Numéro de téléphone
          </label>
          <div className="flex h-10 overflow-hidden rounded-md border border-[#d4dfd7] focus-within:ring-2 focus-within:ring-ring">
            <span className="flex items-center border-r border-[#d4dfd7] bg-[#f7f9f8] px-3 text-[13px] text-[#687c6e]">
              +229
            </span>
            <Input
              id="agency-phone"
              type="tel"
              maxLength={10}
              className="h-full rounded-none border-0"
              placeholder="01 99 01 02 03"
              {...register('phone')}
            />
          </div>
          {errors.phone && <p className="text-xs text-red-500">{errors.phone.message}</p>}
        </div>
        <div className={`${fieldClass} sm:col-span-2`}>
          <label className={labelClass} htmlFor="agency-address">
            Adresse
          </label>
          <Textarea
            id="agency-address"
            className="min-h-[60px] border-[#d4dfd7]"
            placeholder="Rue, ville, département"
            {...register('address')}
          />
          {errors.address && <p className="text-xs text-red-500">{errors.address.message}</p>}
        </div>
      </div>
    </section>
    {includeAdmin && (
      <section className="mt-4 space-y-3 border-t border-[#e8edea] pt-4">
        <h3 className="text-sm font-semibold text-[#354c3c]">Administrateur principal</h3>
        <div className="grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-2">
          <div className={fieldClass}>
            <label className={labelClass} htmlFor="admin-first-name">
              Prénoms
            </label>
            <Input
              id="admin-first-name"
              className={inputClass}
              placeholder="Prénoms"
              {...register('admin_first_name')}
            />
            {errors.admin_first_name && <p className="text-xs text-red-500">{errors.admin_first_name.message}</p>}
          </div>
          <div className={fieldClass}>
            <label className={labelClass} htmlFor="admin-last-name">
              Nom
            </label>
            <Input id="admin-last-name" className={inputClass} placeholder="Nom" {...register('admin_last_name')} />
            {errors.admin_last_name && <p className="text-xs text-red-500">{errors.admin_last_name.message}</p>}
          </div>
          <div className={`${fieldClass} sm:col-span-2`}>
            <label className={labelClass} htmlFor="admin-email">
              Adresse email
            </label>
            <Input
              id="admin-email"
              type="email"
              className={inputClass}
              placeholder="prenom.nom@example.com"
              {...register('admin_email')}
            />
            {errors.admin_email && <p className="text-xs text-red-500">{errors.admin_email.message}</p>}
          </div>
        </div>
      </section>
    )}
    <section className="mt-4 space-y-3 border-t border-[#e8edea] pt-4">
      <h3 className="text-sm font-semibold text-[#354c3c]">Catégories proposées</h3>
      <Controller
        control={control}
        name="category_ids"
        render={({ field }) => (
          <>
            <MultiSelectCategories value={field.value} onValueChange={field.onChange} categories={categories} />
            {errors.category_ids && <p className="text-xs text-red-500">{errors.category_ids.message}</p>}
          </>
        )}
      />
    </section>
  </>
);

AgencyFormContent.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  includeAdmin: PropTypes.bool,
};

export default AgencyFormContent;
